export default "<lib-cloud-account-list #accountList\n  (poolChangingRequested)=\"onPoolChangingRequested($event)\">\n</lib-cloud-account-list>"